"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHelpUrl = useHelpUrl;
var _react = require("react");
var _view = require("../../../selectors/view");
var _hooks = require("../../../hooks");
function useHelpUrl(_ref) {
  let {
    useSelector,
    query
  } = _ref;
  const activeViewName = useSelector(_view.selectActiveView);
  const cianHost = (0, _hooks.useCianHost)({
    useSelector
  });
  const refUrl = (0, _react.useMemo)(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const url = new URL(window.location.href);
    url.hash = `auth=${activeViewName}`;
    return url.toString();
  }, [activeViewName]);
  const queryWithRefUrl = (0, _react.useMemo)(() => {
    const queryParams = new URLSearchParams(query);
    if (refUrl) {
      queryParams.append('ref', refUrl);
    }
    return queryParams.toString();
  }, [query, refUrl]);
  return (0, _react.useMemo)(() => {
    const queryPart = queryWithRefUrl ? `?${queryWithRefUrl}` : '';
    return `${cianHost}/contacts${queryPart}`;
  }, [queryWithRefUrl, cianHost]);
}